import request from '@/utils/request'

const ANALYTICS_TIMEOUT = 60000 // 60s for analytics queries
const EXPORT_TIMEOUT = 120000 // 120s for export operations

export const getDashboardData = (startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/dashboard',
    method: 'get',
    params: { startDate, endDate },
    timeout: ANALYTICS_TIMEOUT
  })

export const getPurchaseMetrics = (startDate?: string, endDate?: string, groupBy?: string) =>
  request({
    url: '/analytics/purchases',
    method: 'get',
    params: { startDate, endDate, groupBy },
    timeout: ANALYTICS_TIMEOUT
  })

export const getEntitlementMetrics = (startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/entitlements',
    method: 'get',
    params: { startDate, endDate },
    timeout: ANALYTICS_TIMEOUT
  })

export const getDeviceMetrics = () =>
  request({
    url: '/analytics/devices',
    method: 'get',
    timeout: ANALYTICS_TIMEOUT
  })

export const getVoiceAssistantMetrics = () =>
  request({
    url: '/analytics/voice-assistant',
    method: 'get',
    timeout: ANALYTICS_TIMEOUT
  })

export const getUserMetrics = () =>
  request({
    url: '/analytics/users',
    method: 'get',
    timeout: ANALYTICS_TIMEOUT
  })

export const getSmartMapUsers = (page?: number, limit?: number, search?: string, startDate?: string, endDate?: string, source?: string) =>
  request({
    url: '/analytics/smart-map-users',
    method: 'get',
    params: { page, limit, search, startDate, endDate, source },
    timeout: ANALYTICS_TIMEOUT
  })

export const exportSmartMapUsersCsv = (search?: string, startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/smart-map-users/export',
    method: 'get',
    params: { search, startDate, endDate },
    responseType: 'blob',
    timeout: EXPORT_TIMEOUT
  })

export const getVoiceAssistantUsers = (page?: number, limit?: number, search?: string, startDate?: string, endDate?: string, source?: string) =>
  request({
    url: '/analytics/voice-assistant-users',
    method: 'get',
    params: { page, limit, search, startDate, endDate, source },
    timeout: ANALYTICS_TIMEOUT
  })

export const exportVoiceAssistantUsersCsv = (search?: string, startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/voice-assistant-users/export',
    method: 'get',
    params: { search, startDate, endDate },
    responseType: 'blob',
    timeout: EXPORT_TIMEOUT
  })

export const getWeAssistUsers = (page?: number, limit?: number, search?: string, startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/weassist-users',
    method: 'get',
    params: { page, limit, search, startDate, endDate },
    timeout: ANALYTICS_TIMEOUT
  })

export const exportWeAssistUsersCsv = (search?: string, startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/weassist-users/export',
    method: 'get',
    params: { search, startDate, endDate },
    responseType: 'blob',
    timeout: EXPORT_TIMEOUT
  })

export const getPurchaseAnalyticsData = (startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/purchase-analytics',
    method: 'get',
    params: { startDate, endDate },
    timeout: ANALYTICS_TIMEOUT
  })

export const getDeviceAnalyticsData = (startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/device-analytics',
    method: 'get',
    params: { startDate, endDate },
    timeout: ANALYTICS_TIMEOUT
  })

export const getDeviceReplacementsData = (startDate?: string, endDate?: string) =>
  request({
    url: '/analytics/device-replacements',
    method: 'get',
    params: { startDate, endDate },
    timeout: ANALYTICS_TIMEOUT
  })
